import { FormControlLabel, Switch, Tooltip, Typography } from "@mui/material";
import SetupCC from "components/setupCC";
import InputField from "components/ui/inputField";
import useApi from "hooks/useApi";
import * as yup from "yup";

const Fees = () => {
  const initialValues = {
    name: "",
  };

  const { fetchData } = useApi();
  const handleChangeStatus = async (id, status, setAllData) => {
    const result = await fetchData({
      method: "put",
      url: `/api/admin/fee/change-status/${id}`,
      data: {
        status,
      },
    });
    if (result?.success) {
      setAllData((allData) =>
        allData?.map((single_data) =>
          single_data.id === id
            ? { ...single_data, status: status === "active" ? 1 : 0 }
            : single_data,
        ),
      );
    }
  };

  return (
    <SetupCC
      name="Fee"
      baseRouteKey="fees"
      moduleKey="fee"
      columns={[
        { id: "name", label: "Name", minWidth: 100 },
        {
          id: "status",
          label: "Active/Inactive",
          style: { width: "60px" },
          align: "center",
        },
        {
          id: "action",
          label: "Actions",
          style: { width: "150px" },
          align: "center",
        },
      ]}
      actions={["edit", "delete"]}
      conditionalColumns={(row, column, value, setAllData) => {
        return (
          <>
            {column.id === "status" ? (
              <Tooltip
                title={
                  <Typography
                    sx={{ textTransform: "capitalize", fontSize: "12px" }}
                  >
                    {row?.status ? "Active" : "Inactive"}
                  </Typography>
                }
              >
                <FormControlLabel
                  control={<Switch />}
                  checked={value === 1 ? true : false}
                  onChange={(e) =>
                    handleChangeStatus(
                      row?.id,
                      e.target.checked ? "active" : "inactive",
                      setAllData,
                    )
                  }
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#27ae61",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#27ae61",
                    },
                  }}
                />
              </Tooltip>
            ) : (
              value
            )}
          </>
        );
      }}
      getInitialValues={(data) => {
        if (data?.id) {
          let obj = {};
          for (const key in initialValues) {
            obj[key] = data[key];
          }
          return obj;
        } else return initialValues;
      }}
      validationSchema={yup.object({
        name: yup.string().required("Name is required!"),
      })}
      allFields={(formik) => (
        <>
          <InputField name="name" label="Name" formik={formik} />
        </>
      )}
    ></SetupCC>
  );
};

export default Fees;